import {
    Box,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

function ChangePasswordDialog({ open, onClose, passwordData, onPasswordData, loading, onSubmit }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            disableEnforceFocus
            disableRestoreFocus
        >
            <DialogTitle sx={{ bgcolor: '#1f2937', color: '#e0f2fe' }}>
                Passwort ändern
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#1f2937', pt: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="Altes Passwort"
                        type="password"
                        value={passwordData.oldPassword}
                        onChange={(e) => onPasswordData({ ...passwordData, oldPassword: e.target.value })}
                        fullWidth
                        disabled={loading}
                        autoComplete="current-password"
                    />
                    <TextField
                        label="Neues Passwort"
                        type="password"
                        value={passwordData.newPassword}
                        onChange={(e) => onPasswordData({ ...passwordData, newPassword: e.target.value })}
                        fullWidth
                        disabled={loading}
                        autoComplete="new-password"
                    />
                    <TextField
                        label="Passwort bestätigen"
                        type="password"
                        value={passwordData.confirmPassword}
                        onChange={(e) => onPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                        fullWidth
                        disabled={loading}
                        autoComplete="new-password"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ bgcolor: '#1f2937' }}>
                <Button
                    onClick={onClose}
                    sx={{ color: '#93c5fd' }}
                    disabled={loading}
                >
                    Abbrechen
                </Button>
                <Button
                    onClick={onSubmit}
                    variant="contained"
                    sx={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: '#fff', borderRadius: '16px' }}
                    disabled={loading}
                >
                    {loading ? 'Wird geändert...' : 'Passwort ändern'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ChangePasswordDialog;
